<template>
  <div style="height: auto !important;" class="layout-serial-number" :style="styleBox">
    <div class="header-serial-number">
<!--      <div class="item title" :style="'font-size: 9px;'"> {{ title }}</div>-->
      <div class="item title" :style="'font-size: 9pt !important;'"> {{ title }} <span class="down-line-custom" >& HƯỚNG DẪN SỬ DỤNG</span></div>
<!--      <div class="item title txt-right" :style="'font-size: 9px!important;'"> {{ modelCode }} </div>-->
      <div class="item title txt-right" :style="'font-size: 9pt!important;'"> {{ modelCodeFirts }} <span class="down-line-custom" >{{ modelCodeLast }}</span></div>
      <div class="p-clearfix"></div>
    </div>
    <div class="bottom-serial-number" :style="'padding: ' + box_padding + 'px 0;'">
      <div class="body-info" >
        <div class="item-info" :style="'font-size: 9px; padding-bottom: 2px; text-align: justify;'"> <!--<br><br><br>--> {{ note }}</div>
        <div class="item-info border-custom" :style="'font-size: 11px;'"> <img :src="imgPhone"/><span>{{ hotline }} </span></div>
        <div class="item-info" :style="'font-size: 10px;'">SERI: {{ serialNumber }}</div>
      </div>
      <div class="body-info body-qr" >
        <qrCode :style="'width:' + qrSize + 'px; height:' + qrSize +'px;'" :logoUrl="logoUrl" :logoSize="logoSize" :codeSize="codeSize" :codeValue="codeValue"/>
      </div>
      <div class="p-clearfix"></div>
    </div>
  </div>
</template>

<script>
import qrCode from './qrCode'
export default {
  props: {
    logoUrl: {
      type: String,
      default: ''
    },
    logoSize: Number,
    codeValue: String,
    codeSize: Number,
    modelCode: String,
    serialNumber: String,
    styleBox: String,
    title: String,
    note: String,
    hotline: String
  },
  components: {
    qrCode
  },
  data() {
    return {
      imgPhone: window.origin + '/assets/images/phone-icon-01.svg',
      title_size: this.$myConstants.converMillimeterToPixel(2.3),
      body_size: this.$myConstants.converMillimeterToPixel(1.9),
      header_padding_bottom: this.$myConstants.converMillimeterToPixel(1),
      qrSize: this.$myConstants.converMillimeterToPixel(18),
      box_padding: this.$myConstants.converMillimeterToPixel(1),
      modelCodeFirts:"",
      modelCodeLast:"",
    }
  },
  async created () {
    this.customModelCode()
  }, methods: {
    customModelCode() {
      var object_model=this.$coreService.splitModelNameQrcode(this.modelCode);
      //console.log("this.modelCode:",this.modelCode)
      this.modelCodeFirts=object_model.modelCodeFirts;
      this.modelCodeLast=object_model.modelCodeLast;
      console.log("this.modelCode:",object_model)
      this.$forceUpdate();
    }
  }
}
</script>
<style lang="scss">
.layout-serial-number{ background: #fff; border: 1px solid #000; display: inline-block;
  .header-serial-number{ border-bottom: 2px solid #000;
    .item{width: 50%; float: left;
      &.title{font-family: "UTM Avo Bold";}
      &.txt-right{text-align: right;}
    }
  }
  .bottom-serial-number{
    .body-info{font-family: "UTM Avo Bold"; width: 60%; float: left;
      .item-info{
        &.border-custom{border-top: 1px solid #000; border-bottom: 1px solid #000;}
        img{width: 12px !important; position: relative; top: 0;}
      }
      &.body-qr{width: 40%;}
    }
  }
  .qr-custom{ float: right;width: 1.8cm; height: 1.8cm;
    img{max-width: 100%; height: auto;}
  }
}
.down-line-custom{
  display: block;
}
</style>